import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { PropsWithChildren, useEffect, useState } from 'react';
import { HideBootLoader } from '../Loader/BootLoader';
import { checkBrowserSupport } from './browserSupport';

export function BrowserGuard({ children }: PropsWithChildren) {
  const [isSupported, setIsSupported] = useState(true);
  const [browserName, setBrowserName] = useState('');
  const [browserVersion, setBrowserVersion] = useState('');

  useEffect(() => {
    const support = checkBrowserSupport(window.navigator.userAgent, import.meta.env.VITE_MIN_BROWSERS);
    setBrowserName(support.name);
    setBrowserVersion(support.version);
    setIsSupported(support.supported);
  }, []);

  if (isSupported) {
    return <>{children}</>;
  }

  return (
    <>
      <HideBootLoader />
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          bgcolor: 'background.default',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Container maxWidth='sm'>
          <Stack spacing={3} alignItems='center' textAlign='center'>
            <Box component='img' src='/foresight-logo.svg' alt='Logo' sx={{ height: 40, mb: 2 }} />
            <Typography variant='h4' component='h1' gutterBottom>
              Browser Not Supported
            </Typography>
            <Typography variant='body1' color='text.secondary'>
              You are using {browserName} {browserVersion}. This application requires a modern browser. Please
              upgrade your browser or switch to Google Chrome.
            </Typography>
            <Button
              variant='contained'
              size='large'
              href='https://www.google.com/chrome/'
              target='_blank'
              rel='noopener noreferrer'
            >
              Download Chrome
            </Button>
          </Stack>
        </Container>
      </Box>
    </>
  );
}
